import { EyeOutlined, RadarChartOutlined } from "@ant-design/icons";
import { Affix, Card, Button } from "antd";
import ListTable from "common/ListTable";
import { NEW_TODO_LISTS_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";
import HandleNotification from "common/Notification";
import CustomFilter from "components/Common/CustomFilter";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  TNA_PLAN_SUMMARY_DETAILS_PERMISSION,
  TNA_PLAN_SUMMARY_GRAPH_PERMISSION,
} from "routes/permissions";
import { cglFormatDate, hasPermission } from "utils/functions";
import { flattenNewTodoSummaryRows } from "./tnaSummaryUtils";

const NewSummaryList = (props) => {
  const { width } = props;
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [permitList, setPermitList] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rangeData, setRangeData] = useState(20);
  const [activeFilters, setActiveFilters] = useState({});

  const canViewDetails = hasPermission([TNA_PLAN_SUMMARY_DETAILS_PERMISSION]);
  const canViewGraph = hasPermission([TNA_PLAN_SUMMARY_GRAPH_PERMISSION]);

  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const getAllPermitList = useCallback(async (filterValues) => {
    setLoading(true);
    const currentFilters = filterValues !== undefined ? filterValues : activeFilters;
    if (filterValues !== undefined) {
      setActiveFilters(filterValues);
    }
    try {
      const response = await getData(NEW_TODO_LISTS_ENDPOINT, false, {
        page: currentPage,
        per_page: rangeData,
        ...currentFilters,
      });
      if (response?.status === 200 && response.data?.code === 200) {
        const rows = Array.isArray(response.data?.data)
          ? response.data.data
          : [];
        const flat = flattenNewTodoSummaryRows(rows);
        console.log("flat", flat);
        setPermitList(flat);
        setTotalData(flat.length);
      } else {
        setPermitList([]);
        HandleNotification(
          "error",
          "bottomRight",
          "Something Went Wrong!",
          null,
        );
      }
    } finally {
      setLoading(false);
    }
  }, [currentPage, rangeData, activeFilters]);

  useEffect(() => {
    getAllPermitList();
  }, [currentPage, getAllPermitList]);

  const columns = useMemo(
    () => [
      {
        title: "Buyar",
        dataIndex: "buyar",
        key: "buyar",
      },
      {
        title: "Buying Office",
        dataIndex: "buying_office",
        key: "buying_office",
      },
      {
        title: "Sales Contract No",
        dataIndex: "sales_contract_no",
        key: "sales_contract_no",
      },
      {
        title: "Style",
        dataIndex: "style",
        key: "style",
      },
      {
        title: "Current Task",
        dataIndex: "current_task",
        key: "current_task",
      },
      {
        title: "Responsible",
        dataIndex: "responsible",
        key: "responsible",
      },
      {
        title: "Due Date",
        dataIndex: "due_date",
        key: "due_date",
        render: (value) => cglFormatDate(value),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
      },
      {
        title: "Variance (Days)",
        dataIndex: "variance",
        key: "variance",
      },
      {
        title: "Comment",
        dataIndex: "comment",
        key: "comment",
      },
      ...(canViewDetails || canViewGraph
        ? [
          {
            title: "",
            key: "actions",
            width: "10%",
            render: (_, record) => (
              <div className="cursore-pointer flex-column">
                {canViewDetails && (
                  <div>
                    <Link
                      to={`/tanda/new-summary/${record?.sales_contract_id}`}
                    >
                      <EyeOutlined /> Details
                    </Link>
                  </div>
                )}
                {canViewGraph && (
                  <div>
                    <Link
                      to={`/tanda/new-progress/${record?.sales_contract_id}`}
                    >
                      <RadarChartOutlined /> Graph
                    </Link>
                  </div>
                )}
              </div>
            ),
          },
        ]
        : []),
    ],
    [canViewDetails, canViewGraph],
  );

  const extra = (
    <Button
      type={showFilter ? "danger" : "primary"}
      size="small"
      onClick={() => setShowFilter(!showFilter)}
      style={{ float: "right" }}
    >
      {`${showFilter ? "Close" : "Open"} Filter Option`}
    </Button>
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header title="T&A Summary" subTitle="" actions={extra} />
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          <CustomFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            tableData={permitList}
            fetchTableData={getAllPermitList}
            filterName="new_todo_style_filter"
          />
          <ListTable
            loading={loading}
            dataSource={permitList}
            columns={columns}
            rowKey="key"
            scroll={{ x: "100%" }}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => setCurrentPage(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
};

export default NewSummaryList;
